import { format } from "date-fns/format";
import { nb } from "date-fns/locale/nb";
import DOMPurify from "dompurify";
import ISirkLogButtons from "features/CenterContent/RoleContent/ISirk/ISirkLogButtons";
import { IncidentNote } from "features/CenterContent/RoleContent/ISirk/types";
import parse from "html-react-parser";
import { FC } from "react";
import { DropsExpandable, Flex, HStack } from "shared/components/Spor";
import { SectionTitle, Text } from "shared/components/typography/TitleStyles";

const ISirkNote: FC<IncidentNote> = ({
  content,
  summary,
  fromDate,
  toDate,
  isirk,
}) => {
  const parsedFromDate = Date.parse(new Date(fromDate).toISOString());
  const parsedToDate = Date.parse(new Date(toDate).toISOString());

  return (
    <DropsExpandable
      title={
        <div>
          <HStack>
            <SectionTitle>{summary}</SectionTitle>
            <Text>{isirk}</Text>
          </HStack>

          <Text>
            {format(parsedFromDate, "dd.MM.yyyy", { locale: nb })} -{" "}
            {format(parsedToDate, "dd.MM.yyyy", { locale: nb })}
          </Text>
        </div>
      }
      collapsible
    >
      <Flex color="text" flexDirection="column" p="12px">
        <ISirkLogButtons isirk={isirk} />
        {parse(DOMPurify.sanitize(content))}
      </Flex>
    </DropsExpandable>
  );
};

export default ISirkNote;
